// export const API_BASE_URL = "http://192.168.0.231"; //live vpn
// export const API_BASE_URL = "http://45.248.33.161:5010"; // staging
export const API_BASE_URL = "https://api.marsool.aryabyte.com";

export const ApiEndpoints = {
  CONTACT_US: {
    create: `${API_BASE_URL}/api/v1/web/contactus`,
  },

  BLOGS: {
    list: `${API_BASE_URL}/api/v1/web/blog`,
  },
  BLOGS_DETAILS: {
    list: (id) => `${API_BASE_URL}/api/v1/web/blog/${id}`,
  },
  TESTIMONIALS: {
    list: `${API_BASE_URL}/api/v1/web/testimonials`,
  },
  FAQS: {
    list: `${API_BASE_URL}/api/v1/web/faqs`,
  },
  PRIVACY_POLICY: {
    list: `${API_BASE_URL}/api/v1/web/legalcontent/privacy_policy`,
  },
  TERMS_AND_CONDITIONS: {
    list: `${API_BASE_URL}/api/v1/web/legalcontent/terms_and_conditions`,
  },
  OUR_TEAM: {
    list: `${API_BASE_URL}/api/v1/web/ourteam`,
  },
  TRACK_ORDER: {
    list: (id) => `${API_BASE_URL}/api/v1/common/order-history-track/${id}`,
  },

  CONFIRM_ORDER: {
    list: (id) => `${API_BASE_URL}/api/v1/web/order/${id}`,
    edit: (id) => `${API_BASE_URL}/api/v1/web/order/update-order/${id}`,
  },
};
